export class ListThreatHuntingScanRequestsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ThreatHuntingStatus",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "statuses",
            "baseName": "statuses",
            "type": "Array<ThreatHuntingStatus>",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortThreatHuntingScanRequestsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListThreatHuntingScanRequestsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
